module.exports = __webpack_public_path__ + "img/s2-2.463ed721.webp";